<div class="canvas-container-d-s" [id]="'canvas-container'+currentElementId">
  <canvas
      [id]="'digital-signature'+currentElementId"
      class="digital-signature"
  ></canvas>
</div>
<!-- integrate buttons assiciated functions and attributes -->
<!-- <ion-button
  *ngIf="sharedDataService.isTablet"
  expand="full"
  class="action-btn"
  (click)="onContinue()"
  [disabled]="(!showDigitalInk && !isConfirm) || (showDigitalInk &&  (!isConfirm || !isSignatureFilled))"
>
  {{'SHARED_TEXT.CONTINUE' | translate}}</ion-button
>

<ion-button
    *ngIf="sharedDataService.isTablet && showGenerateJsonFileButton"
    expand="full"
    class="action-btn"
    (click)="onContinue(true)"
    [disabled]="(!showDigitalInk && !isConfirm) || (showDigitalInk &&  (!isConfirm || !isSignatureFilled))"
>
    Generate JSON File
</ion-button> -->
